import { useState } from "react";
import { Clock, Users, Check } from "lucide-react";
import { Spinner } from "../Spinner";

export function MealSuggestionCard({
  suggestion,
  onSaveRecipe,
  onAddMissingToList,
}) {
  const [isAdding, setIsAdding] = useState(false);
  const [addedToList, setAddedToList] = useState(false);

  const haveIngredients = suggestion.ingredients.filter((ing) => ing.onHand);
  const needIngredients = suggestion.ingredients.filter((ing) => !ing.onHand);

  const handleAddMissingToList = async () => {
    setIsAdding(true);
    try {
      await onAddMissingToList();
      setAddedToList(true);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
      <div>
        <p className="text-base font-semibold text-gray-900 mb-1.5">
          {suggestion.mealName}
        </p>
        <div className="flex gap-1.5">
          <span className="flex items-center gap-1 text-xs text-gray-600 bg-gray-100 rounded-full px-2.5 py-1">
            <Clock className="w-3 h-3" />
            {suggestion.timeMins} min
          </span>
          <span className="flex items-center gap-1 text-xs text-gray-600 bg-gray-100 rounded-full px-2.5 py-1">
            <Users className="w-3 h-3" />
            {suggestion.servings}
          </span>
        </div>
      </div>

      {haveIngredients.length > 0 && (
        <div>
          <p className="text-xs font-medium text-green-700 mb-1">You have</p>
          <div className="flex flex-wrap gap-1.5">
            {haveIngredients.map((ing, index) => (
              <span
                key={index}
                className="text-xs text-green-800 bg-green-50 rounded-md px-2 py-1"
              >
                {ing.name}
              </span>
            ))}
          </div>
        </div>
      )}

      {needIngredients.length === 0 ? (
        <div className="bg-green-50 rounded-lg px-2.5 py-2 flex items-center gap-1.5">
          <Check className="w-3.5 h-3.5 text-green-700" />
          <span className="text-xs font-medium text-green-800">
            Ready to cook — nothing to buy
          </span>
        </div>
      ) : (
        <div>
          <p className="text-xs font-medium text-amber-700 mb-1">
            You'll need
          </p>
          <div className="flex flex-wrap gap-1.5">
            {needIngredients.map((ing, index) => (
              <span
                key={index}
                className="text-xs text-amber-800 bg-amber-50 rounded-md px-2 py-1"
              >
                {ing.name}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="flex gap-2 mt-1">
        <button
          type="button"
          onClick={onSaveRecipe}
          className="flex-1 text-center text-sm font-medium text-white bg-gray-900 rounded-lg py-2 hover:bg-gray-800 transition-colors"
        >
          Save recipe
        </button>
        {needIngredients.length > 0 && !addedToList && (
          <button
            type="button"
            onClick={handleAddMissingToList}
            disabled={isAdding}
            className="flex-1 flex items-center justify-center gap-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg py-2 hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            {isAdding && <Spinner size="sm" className="text-gray-700" />}
            {isAdding ? "Adding..." : `Add ${needIngredients.length} to list`}
          </button>
        )}
      </div>
    </div>
  );
}
